import {
  accountStatus,
  chatRoomStatus,
  interventionStatus,
  invoiceStatus,
  offerStatus,
  ticketStatus,
} from "./constants";

export const clientStatus = [
  {tabTitle: "Tous", label: "Tous", value: undefined, count: "0"},
  {
    tabTitle: "Actifs",
    label: "Actif",
    value: accountStatus.VALID,
    count: "0",
  },
  {
    tabTitle: "Bloqués",
    label: "Bloqué",
    value: accountStatus.DISABLED,
    count: "0",
  },
];

export const technicianStatus = [
  {tabTitle: "Tous", label: "Tous", value: undefined, count: "0"},
  {
    tabTitle: "Nouveaux",
    label: "Nouveau",
    value: accountStatus.INITIATED,
    count: "0",
  },
  {
    tabTitle: "En attente",
    label: "En attente",
    value: accountStatus.VALIDATION_WAITING,
    count: "0",
  },
  {
    tabTitle: "Actifs",
    label: "Actif",
    value: accountStatus.VALID,
    count: "0",
  },
  {
    tabTitle: "Bloqués",
    label: "Bloqué",
    value: accountStatus.DISABLED,
    count: "0",
  },
  {
    tabTitle: "Rejetés",
    label: "Rejeté",
    value: accountStatus.DISALLOW,
    count: "0",
  },
];

export const chatRoomStatusOptions = [
  {
    label: "En cours",
    tabTitle: "En cours",
    value: chatRoomStatus.INITIATED,
  },
  {
    tabTitle: "Accepté",
    label: "Accepté",
    value: chatRoomStatus.ACCEPTED,
  },
  {
    tabTitle: "Annulées",
    label: "Annulée",
    value: chatRoomStatus.CANCELED,
  },

  {
    tabTitle: "Terminé",
    label: "Terminé",
    value: chatRoomStatus.ENDED,
  },
  {
    tabTitle: "Bloqué",
    label: "Bloqué",
    value: chatRoomStatus.HIDDEN,
  },
];

export const ticketStatusOptions = [
  {tabTitle: "Tous", label: "Tous", value: undefined, count: "0"},
  {
    tabTitle: "Nouveaux",
    label: "Nouveau",
    value: ticketStatus.INITIATED,
    count: "0",
  },
  {
    tabTitle: "En cours",
    label: "En cours",
    value: ticketStatus.PROCESSING,
    count: "0",
  },
  {
    tabTitle: "Résolus",
    label: "Résolu",
    value: ticketStatus.RESOLVED,
    count: "0",
  },
  {
    tabTitle: "Non Résolus",
    label: "Non Résolu",
    value: ticketStatus.UNRESOLVED,
    count: "0",
  },
  {
    tabTitle: "Archivés",
    label: "Archivé",
    value: ticketStatus.ARCHIVED,
    count: "0",
  },
];

export const offerStatusOptions = [
  {tabTitle: "Toutes", label: "Tous", value: undefined, count: "0"},
  {
    tabTitle: "En attente de validation",
    label: "En attente",
    value: offerStatus.VALIDATION_WAITING,
    count: "0",
  },

  {
    tabTitle: "Publiées",
    label: "Publiée",
    value: offerStatus.PUBLIC,
    count: "0",
  },
  {
    tabTitle: "Cachées",
    label: "Cachée",
    value: offerStatus.DISABLED,
    count: "0",
  },
  {
    tabTitle: "Non validées",
    label: "Non validée",
    value: offerStatus.DISALLOW,
    count: "0",
  },
  {
    tabTitle: "En cours",
    label: "En cours",
    value: offerStatus.PROCESSING,
    count: "0",
  },
  {
    tabTitle: "Terminées",
    label: "Terminée",
    value: offerStatus.ENDED,
    count: "0",
  },
  // {
  //   tabTitle: "Bloquées",
  //   label: "Bloquée",
  //   value: offerStatus.DISABLED,
  //   count: "0",
  // },
];
export function getOfferStatusColor({status}) {
  let color;
  let bg;
  switch (status) {
    case offerStatus.PUBLIC:
      color = "#27AA00";
      bg = "#27AA001A";
      break;
    case offerStatus.VALIDATION_WAITING:
      color = "#FFCC00";
      bg = "#FFCC001A";
      break;
    case offerStatus.ENDED:
      color = "#19295C";
      bg = "#19295C1A";
      break;
    case offerStatus.PROCESSING:
      color = "#FF6600";
      bg = "#FF66001A";
      break;

    case offerStatus.DISABLED:
      color = "#A2A2A2";
      bg = "#A2A2A21A";
      break;
    case offerStatus.DISALLOW:
      color = "#D80027";
      bg = "#D800271A";
      break;

    default:
      color = "#3E4954";
      bg = "#FFFFFF";
      break;
  }

  return {bg, color};
}

export function getInterventionStatusColor({status}) {
  let color;
  let bg;
  switch (status) {
    case interventionStatus.NEW:
      color = "#27AA00";
      bg = "#27AA001A";
      break;
    case interventionStatus.PROCESSING:
      color = "#FF6600";
      bg = "#FF66001A";
      break;
    case interventionStatus.ENDED:
      color = "#19295C";
      bg = "#19295C1A";
      break;
    case interventionStatus.CANCELED:
      color = "#D80027";
      bg = "#D800271A";
      break;
    case interventionStatus.REPORTED:
      color = "#9B51E0";
      bg = "#9B51E01A";
      break;
    default:
      color = "#3E4954";
      bg = "#FFFFFF";
      break;
  }

  return {bg, color};
}

export function getInterventionStatusLabel(intervention) {
  if (
    intervention?.status !== interventionStatus.ENDED &&
    intervention?.ended_byTech &&
    !intervention?.ended_byClient
  ) {
    return "En attente de confirmation client";
  }

  if (
    intervention?.status !== interventionStatus.ENDED &&
    intervention?.ended_byClient &&
    !intervention?.ended_byTech
  ) {
    return "En attente de confirmation prestataire";
  }

  return (
    interventionStatusOptions.find(
      (option) => option.value === intervention?.status,
    )?.label || "Statut inconnu"
  );
}

export function getTicketStatusColor({status}) {
  let color;
  let bg;
  switch (status) {
    case ticketStatus.INITIATED:
      color = "#3E4954";
      bg = "#CED1D4";
      break;
    case ticketStatus.PROCESSING:
      color = "#FF6600";
      bg = "#FFD8BF";
      break;
    case ticketStatus.ARCHIVED:
      color = "#19295C";
      bg = "#C5C9D6";
      break;
    case ticketStatus.UNRESOLVED:
      color = "#D80027";
      bg = "#F5BFC9";
      break;
    case ticketStatus.RESOLVED:
      color = "#27AA00";
      bg = "#C9E9BF";
      break;
    default:
      color = "#3E4954";
      bg = "#F0F2F5";
      break;
  }

  return {bg, color};
}

export const interventionStatusOptions = [
  {tabTitle: "Toutes", label: "Tous", value: undefined, count: "0"},
  {
    tabTitle: "Nouvelles",
    label: "Nouvelle",
    value: interventionStatus.NEW,
    count: "0",
  },
  {
    tabTitle: "En cours",
    label: "En cours",
    value: interventionStatus.PROCESSING,
    count: "0",
  },
  {
    tabTitle: "Terminées",
    label: "Terminée",
    value: interventionStatus.ENDED,
    count: "0",
  },

  {
    tabTitle: "Annulées",
    label: "Annulée",
    value: interventionStatus.CANCELED,
    count: "0",
  },
  // {
  //   tabTitle: "Non validées",
  //   label: "Non validée",
  //   value: interventionStatus.DISALLOW,
  //   count: "0",
  // },
  {
    tabTitle: "Reportées",
    label: "Reportée",
    value: interventionStatus.REPORTED,
    count: "0",
  },
];

export const invoiceStatusOptions = [
  {tabTitle: "", label: "Payée", value: invoiceStatus.PAID, count: "0"},
  {
    tabTitle: "",
    label: "Non payée",
    value: invoiceStatus.NOT_PAID,
    count: "0",
  },
];

export const rejectReasons = Object.freeze({
  CNI_UP: "Face avant CNI manquante ou pas claire",
  CNI_DOWN: "Face arrière CNI manquante ou pas claire",
  DIPLOMA: "Diplôme manquant ou pas clair",
  OTHER: "Autres",
});
